import { css } from 'styled-components';
import {
  getTypography, TypographyName, getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  $noPad,
  $active,
}) => css`
  ${!$noPad && getSpacing.padding(theme, [SpacingName.SMALLER, SpacingName.SMALL])}
  ${getTypography(theme, TypographyName.SMALL)}
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;

  ${$active && `
    background-color: ${theme.palettes.neutrals.lighter};
  `}

  &:hover {
    background-color: ${theme.palettes.neutrals.lighter};
  }
`;

export const icon: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.neutrals.medium};
  line-height: 0;
  ${getSpacing.marginRight(theme, SpacingName.SMALLER)}
  flex-shrink: 0;
`;

export const info = css`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  position: relative;
  padding-right: 1.5rem;
  line-height: 1;
`;

export const label: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.neutrals.medium};
  text-transform: uppercase;
`;

export const selectedIcon: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.status.success};
  line-height: 0;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: -2px;
`;
